import React from "react";
import Grid from "@material-ui/core/Grid";
import { TextField } from "final-form-material-ui";
import { Field } from "react-final-form";
import { List, CrudForm, ListApi, FormApi } from "elentari";
import { servicosApi as api } from "../../services/Api";
import ImagePicker from "../../components/ImagePicker";

export function ServicosList(props) {
  const listOptions = {
    defaultOrder: "nome",
    fields: {
      id: {
        label: "Id",
      },
      nome: {
        label: "Nome",
      },
    },
  };

  return (
    <ListApi api={api}>
      {({ getPage, getCount, handleDelete }) => (
        <List
          {...props}
          withPaper
          deleteItem={handleDelete}
          onClickEdit={(item) => props.history.push(`/servicos/${item.id}`)}
          onClickNew={() => props.history.push("/servicos/new")}
          getPage={getPage}
          getCount={getCount}
          listOptions={listOptions}
        />
      )}
    </ListApi>
  );
}

export function ServicosForm(props) {
  const validate = (values) => ({
    nome: values.nome ? undefined : "Obrigatório",
  });

  const submitDecorator = async ({ id, data, handleSubmit }) => {
    const result = await handleSubmit({ id, data });
    if (result.ok && Array.isArray(data.iconUrl)) {
      const formData = new FormData();
      formData.append("image", data.iconUrl[0].file);
      await api.uploadIcon(result.id || id, formData);
    }
    return result;
  };

  return (
    <FormApi submitDecorator={submitDecorator} api={api} {...props}>
      {({ handleSubmit, getItem }) => (
        <CrudForm
          withPaper
          validate={validate}
          history={props.history}
          getItem={getItem}
          onSubmit={handleSubmit}
        >
          <Grid container spacing={16}>
            <Grid item sm="auto" xs={12}>
              <Field
                name="iconUrl"
                label="Icone"
                defaultImage={require("../../images/service-default.png")}
                component={ImagePicker}
                width={200}
                height={200}
              />
            </Grid>
            <Grid item sm xs={12}>
              <Field
                fullWidth
                autoFocus
                component={TextField}
                label="Nome"
                name="nome"
              />
            </Grid>
          </Grid>
        </CrudForm>
      )}
    </FormApi>
  );
}
